module.exports = __webpack_public_path__ + "static/media/lexus-vest.8a36d71c.svg";